// extracted by mini-css-extract-plugin
module.exports = {"welcome":"home_welcome__1sIhP","title":"home_title__1FwMg","description":"home_description__pAsAq"};